angular.module('capability-ng-global').run(function(log: any) {
  ['info', 'success', 'warn', 'error'].forEach((channel) => {
    log.user.on(channel, (event: any) => {
      const details = event.message.title ? event.message.content : '';
      const hasHTMLInDetails = details.indexOf('</') >= 0;
      const position = hasHTMLInDetails ? 'top' : 'bottom';

      window['HIP'].fn.notify({
        status: event.channel === 'warn' ? 'warning' : event.channel,
        title: event.message.title || event.message.content,
        delay: event.message.timeout,
        details,
        position
      });
    });
  });
});



// WEBPACK FOOTER //
// ./app/lib/global/configuration/global_notification.ts